import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";

import { onRulesCall } from "../../server/getFileUploadRulesCall/file-upload-rules-call";
import { decodeHTMLEntities } from "../../utils/htmlEntityDecoder";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LessonHTMLViewer from "../../components/lessonHTMLViewer";
import TabNavigator from "../../components/tabNavigator";

//Local Components
import { FaSave, FaArrowLeft } from "react-icons/fa";
import SessionManager from "../../utils/authHandling/session-manager";
import SpinnerLoader from "../../components/spinnerLoader";
import "./edit-diagnostic-prepost-test-page-style.css";
import DiagnosticPrePostTestInfo from "./components/diagnosticPrePostTestInfo";
import DiagnosticPrePostQuestions from "./components/diagnosticPrePostQuestions";
import { getDiagnosticSubjectLevelDetailsCall, createDiagnosticTestCall } from "../../server/diagnosticsCall/diagnostics-call";

class EditDiagnosticPrePostTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //Diagnostic Test Info
      diagnosticTestType: 1,
      diagnosticSubjectLevelId: sessionStorage.diagnosticSubjectLevelId,
      diagnosticTestId: sessionStorage.diagnosticTestId,
      subjectName: "",
      levelName: "", 
      diagnosticTest: {
        Id:sessionStorage.diagnosticTestId,
        DiagnosticSubjectLevelId: sessionStorage.diagnosticSubjectLevelId,
        DiagnosticType: 1,
        Status: 0,
        Questions: []
      },
      //For questions
      quizQuestionModel: [],
      quizQuestionRubricModelList: [],
      quizQuestionResponseModelList: [],
      loading: false,
      redirect: false,
      previewId: null,
      quizRules: [],
      firstLoading: true
    };
    this.onChange = this.onChange.bind(this);
    this.getDiagnosticSubjectLevelDetails = this.getDiagnosticSubjectLevelDetails.bind(this);
    this.saveDiagnosticTest = this.saveDiagnosticTest.bind(this);
    this.removePreviewId = this.removePreviewId.bind(this);
    this.isPendingOrNotCreated = this.isPendingOrNotCreated.bind(this);
  }

  onChange(field, value) {
    this.setState({ [field]: value });
  }

  getDiagnosticTestIdByType(diagnosticTests, type) {
    if(!diagnosticTests || diagnosticTests.length === 0) return null;

    return diagnosticTests[0];
  }

  getDiagnosticSubjectLevelDetails() {
    this.setState({ loading: true });
    
    getDiagnosticSubjectLevelDetailsCall(this.state.diagnosticSubjectLevelId, true)
    .then((response) => {
        const diagnosticTest = this.getDiagnosticTestIdByType(response.DiagnosticTests, this.state.diagnosticTestType) ?? this.state.diagnosticTest;

        this.setState({
            loading: false,
            firstLoading: false,
            subjectName: response.SubjectName,
            levelName: response.LevelName,
            diagnosticTest: diagnosticTest,
            lessonGrade: response.LevelCode,
            lessonSubject: response.SubjectCode,
            diagnosticTestStatusDescription: response.DiagnosticTestStatusDescription,
            quizQuestionModel: diagnosticTest.Questions.map((question) => ({Id: question.Id, Desc: question.Description })),
            quizQuestionResponseModelList: diagnosticTest.Questions.map((question) => question.Responses.map((response) => ({ Id: response.Id, Response: response.Description, Correct: `${response.IsCorrect}` })))
        });
    })
    .catch((error) => {
        this.setState({ loading: false, firstLoading: false });
        console.log(error);
    });
  }

  /**
   * Function to save the diagnostic test
   * @param {number} operation - 1: Save, 2: Publish
   */
  saveDiagnosticTest(operation) {  
    const newQuestions = this.state.quizQuestionModel;
    const newAnswers = this.state.quizQuestionResponseModelList;

    const questions = this.buildDiagnosticTestQuestions(newQuestions, newAnswers);
    const previousStatus = this.state.diagnosticTest.Status;
    this.setState({ 
      diagnosticTest: {
        ...this.state.diagnosticTest,
        Status: operation,
        Questions: questions
      }
    }, function () {
      
      const validationResult = this.isValidateDiagnosticTestQuestionsAndAnswers(this.state.diagnosticTest, operation);
      
      if(!validationResult.isValid) {
        this.setState({
          diagnosticTest: {
            ...this.state.diagnosticTest,
            Status: previousStatus
          }
        }, function() {
          alert(validationResult.message);
        });
        return;
      }

      this.setState({ loading: true });

      createDiagnosticTestCall(this.props.language, this.state.diagnosticTest)
      .then((response) => {
        if(operation === 2) {
          const self = this;

          this.setState({ loading: false}, function() {
            this.getDiagnosticSubjectLevelDetails();

            setTimeout(() => {
              alert(response.Messages);
              self.setState({ redirect: true });
            }, 200);
          });
        }
        else {
          this.setState({ 
            loading: false,
            diagnosticTest: {
            ...this.state.diagnosticTest,
            Id: response.DiagnosticTestId
          }}, function() {
            this.getDiagnosticSubjectLevelDetails();

            setTimeout(() => {
              alert(response.Messages);
            }, 200);
          });
        }
      })
      .catch((error) => {
        alert(error.response.data.Messages);
        this.setState({ loading: false });
      });
    });
  }

  buildDiagnosticTestQuestions(newQuestions, newAnswers) {
    const questions = newQuestions?.map((newQuestion, index) => {
        const question = {
          Id: newQuestion.Id,
          Description: decodeHTMLEntities(newQuestion.Desc),
          Responses: []
        };
        
        newAnswers[index].forEach((newAnswer, c) => {
          question.Responses.push({
            Id: newAnswer.Id,
            Description: decodeHTMLEntities(newAnswer.Response),
            IsCorrect: newAnswer.Correct
          });
        });

        return question ?? [];
    });

   return questions; 
  }

  isValidateDiagnosticTestQuestionsAndAnswers(diagnosticTest, operation) {
    const { intl } = this.props;
    const questions = diagnosticTest.Questions;

    if (!diagnosticTest.Instructions || !diagnosticTest.Instructions.trim() === "") {
        return { isValid: false, message: intl.formatMessage({ id: "d_diagnostic_test_invalid_instructions" }) };
    }

    if (!questions.every(q => q.Description && q.Description.trim() !== "")) {
        return { isValid: false, message: intl.formatMessage({ id: "d_diagnostic_test_invalid_requests" }) };
    }

    if (!questions.every(q =>
        q.Responses.every(r => r.Description && r.Description.trim() !== "")
    )) {
        
        return { isValid: false, message: intl.formatMessage({ id: "d_diagnostic_test_invalid_responses" }) };
    }
    
    if (!questions.every(q =>
        q.Responses.length >= 2 && q.Responses.some(r => r.IsCorrect === '1')
    )) {
        
        return { isValid: false, message: intl.formatMessage({ id: "d_diagnostic_test_invalid_count_responses" }) };
    }

    if (operation === 2 && questions.length < 7) {
      return { isValid: false, message: intl.formatMessage({ id: "d_diagnostic_test_invalid_count_questions" }) };
    }

    return { isValid: true, message: "" };
  }

  componentDidMount() {
    // this.getQuiz();
    this.getDiagnosticSubjectLevelDetails();
    onRulesCall().then((data) => {
      this.setState({ fileRules: data });
    });
  }
  removePreviewId() {
    this.setState({ previewId: null });
  }

  getCardColorByTestStatus(status) {
    switch (status) {
        case 0:
            return "#C26060";
        case 1:
            return "#327FB2";
        default:
            return "#88C479";
    }
}


  isPendingOrNotCreated(){
    return (!this.state.diagnosticTest || !this.state.diagnosticTest.Status || this.state.diagnosticTest.Status === 1)
  }

  render() {
    
    if(this.state.firstLoading || typeof this.state.fileRules === undefined || this.state.fileRules == null || this.state.fileRules.length === 0){
       return <SpinnerLoader />
    }
    
    const sections = [
      {
        sectionTitle: "Info",
        sectionContent: (
          <DiagnosticPrePostTestInfo
            onChange={this.onChange}
            state={this.state}
            language={this.props.language}
            fileRules={this.state.fileRules}
          />
        ),
      },
      {
        sectionTitle: "Preguntas",
        sectionContent: (
          <DiagnosticPrePostQuestions
            onChange={this.onChange}
            state={this.state}
            language={this.props.language}
            fileRules={this.state.fileRules}
            editDisabled={!this.isPendingOrNotCreated()}
          />
        ),
      },
    ];

    return (
      <Container fluid className="card-alt">
        <Row>
          <Col xs={12}>
            <Link to="diagnostic">
              <Button
                style={{ marginBottom: "10px", marginLeft: "5px" }}
                variant="warning"
              >
                <FaArrowLeft /> <FormattedMessage id="d-go-back" />
              </Button>
            </Link>
            <Button
                className="btn-save-test"
                style={{ marginBottom: "10px" }}
                onClick={() => this.saveDiagnosticTest( this.isPendingOrNotCreated() ? 1 : 2)}
                disabled={this.state.loading}
              >
                <FaSave /> <FormattedMessage id="d-save-test" />
              </Button>

            { this.isPendingOrNotCreated() && 
              (
              <><Button
                  className="btn-publish-test"
                  style={{ marginBottom: "10px" }}
                  onClick={() => this.saveDiagnosticTest(2)}
                  disabled={this.state.loading}
                >
                <FaSave /> <FormattedMessage id="d-publish-test" />
              </Button></>)
            }
          </Col>
        </Row>
        <div>
          <br />
          <Row>
            <Col xs={12} md={8}>
              <h3>{`${this.state.subjectName} ${this.state.levelName}`}</h3>
            </Col>
          </Row>
          <Row className="RegionDesc">
              <Col xs={2}>
               
                  <div>
                  <p>
                    Quiz ID: <b>{this.state.diagnosticTest.Id ?? <FormattedMessage id="d-status-quiz-id-pending" /> }</b> <br />
                  </p>
                  <p>
                    <FormattedMessage id="vl-status" />:{" "}
                    <b style={{color: this.getCardColorByTestStatus(this.state.diagnosticTest.Status)}}>{ this.state.diagnosticTestStatusDescription ?? ""} </b>
                  </p>
                  </div>
              
              </Col>
          </Row> 
          <hr />
        </div>
        
        { this.state.loading ?  <SpinnerLoader /> : <TabNavigator sections={sections} defaultActive="Info" /> }
        <div
          style={{
            bottom: "0",
            right: "0",
            position: "fixed",
            textAlign: "center",
            zIndex: "100",
          }}
        >
          <FontAwesomeIcon
            onClick={() => this.setState({ previewId: 5 })}
            icon={faEye}
            size="4x"
            color="#fff"
            style={{
              backgroundColor: "rgb(88, 145, 153)",
              height: "70px",
              width: "70px",
              padding: "5px",
              borderRadius: "100%",
              margin: "10px",
            }}
          />
          <p>
            <FormattedMessage id="preview" />
          </p>

          <LessonHTMLViewer
            contentId={this.state.previewId}
            lessonId={this.state.diagnosticTest.Id}
            language={this.props.language}
            removePreviewId={this.removePreviewId}
          />
        </div>
      </Container>
      
    );
  }
}

export default injectIntl(EditDiagnosticPrePostTest);
